import { render, staticRenderFns } from "./VueDataTableIcons.vue?vue&type=template&id=b62468c0&scoped=true"
import script from "./VueDataTableIcons.vue?vue&type=script&lang=js"
export * from "./VueDataTableIcons.vue?vue&type=script&lang=js"
import style0 from "./VueDataTableIcons.vue?vue&type=style&index=0&id=b62468c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62468c0",
  null
  
)

export default component.exports